import { edgeOpsNum } from './ops-unit';
import { Port } from './port';
import { SystemAlarmSetting, SystemAlarmSettingFns } from './system-alarm-setting';

export const systemChannelGroupNum = 101;
export const systemChannelGroupName = 'SYSTEM STATUS';
export const systemChannelCategoryName = 'SYSTEM';
export const defaultMachineryCategoryName = 'MACHINERY';
export const systemChannelType = 'System Status';

export interface SystemChannel {
    channelId: string;
    channelNum: string;
    channelName: string;
    channelType: string;
    systemAlarmSetting: SystemAlarmSetting;
    fcuNum: number;
}

export function getOpsChannel(opsNum: number, location?: string): SystemChannel {
    if (!opsNum || opsNum < 1 || opsNum > 17) return;
    let opsNumString = opsNum.toString().padStart(2, '0');

    let channelName = `NO.${opsNum} OPERATOR STATION`;
    if (location) channelName = `NO.${opsNum} OPERATOR STATION (${location})`;

    if (opsNum == edgeOpsNum) {
        channelName = `iEdge OPS`;
    }

    return {
        channelId: `0000${opsNumString}`,
        channelNum: `SYS000${opsNumString}`,
        channelName: channelName,
        channelType: systemChannelType,
        systemAlarmSetting: SystemAlarmSettingFns.createOpsSetting(),
        fcuNum: 1,
    };
}

export function getFcuChannels(fcuNum: number, location?: string): SystemChannel[] {
    if (!fcuNum || fcuNum < 1 || fcuNum > 8) return;
    let fcuANumString = 50 + (fcuNum * 2 - 1);
    let fcuBNumString = 50 + fcuNum * 2;

    let channelNameA = `NO.${fcuNum} FIELD CONTROL UNIT - A`;
    let channelNameB = `NO.${fcuNum} FIELD CONTROL UNIT - B`;
    if (location) {
        channelNameA = `NO.${fcuNum} FIELD CONTROL UNIT - A (${location})`;
        channelNameB = `NO.${fcuNum} FIELD CONTROL UNIT - B (${location})`;
    }

    return [
        {
            channelId: `0000${fcuANumString}`,
            channelNum: `SYS000${fcuANumString}`,
            channelName: channelNameA,
            channelType: systemChannelType,
            systemAlarmSetting: SystemAlarmSettingFns.createFcuSetting(),
            fcuNum: fcuNum,
        },
        {
            channelId: `0000${fcuBNumString}`,
            channelNum: `SYS000${fcuBNumString}`,
            channelName: channelNameB,
            channelType: systemChannelType,
            systemAlarmSetting: SystemAlarmSettingFns.createFcuSetting(),
            fcuNum: fcuNum,
        },
    ];
}

export function getFcuIOChannel(fcuNum: number): SystemChannel {
    if (!fcuNum || fcuNum < 1 || fcuNum > 8) return;

    return {
        channelId: `00040${fcuNum}`,
        channelNum: `SYS0040${fcuNum}`,
        channelName: `NO.${fcuNum} FIELD CONTROL UNIT I/O`,
        channelType: systemChannelType,
        systemAlarmSetting: SystemAlarmSettingFns.createFcuIOSetting(),
        fcuNum: fcuNum,
    };
}

export function getFuChannel(fcuNum: number, fuNumber: number, numSlot?, location?: string): SystemChannel {
    if (!fcuNum || fcuNum < 1 || fcuNum > 8) return;
    if (!fuNumber || fuNumber < 1 || fuNumber > 20) return;
    let fuNumString;
    if (fcuNum == 1) {
        fuNumString = 100 + fuNumber;
    } else {
        fuNumString = fcuNum * 10 + 100 + fuNumber;
    }

    let channelName = `NO.${fcuNum} FCU - No.${fuNumber} FIELD UNIT `;
    if (location) channelName = `NO.${fcuNum} FCU - No.${fuNumber} FIELD UNIT (${location})`;

    return {
        channelId: `000${fuNumString}`,
        channelNum: `SYS00${fuNumString}`,
        channelName: channelName,
        channelType: systemChannelType,
        systemAlarmSetting: SystemAlarmSettingFns.createFuSetting(numSlot),
        fcuNum: fcuNum,
    };
}

export function getCeuChannel(fcuNum: number, ceuNum: number, ceuPorts?: Port[], location?: string): SystemChannel {
    if (!fcuNum || fcuNum < 1 || fcuNum > 8) return;
    if (!ceuNum || ceuNum < 1 || ceuNum > 16) return;

    let ceuString;
    if (fcuNum == 1) {
        ceuString = 300 + ceuNum;
    } else {
        ceuString = fcuNum * 10 + 300 + ceuNum;
    }

    let channelName = `NO.${fcuNum} FCU - NO.${ceuNum} COMMUNICATION EXTENSION UNIT`;
    if (location) channelName = `NO.${fcuNum} FCU - NO.${ceuNum} COMMUNICATION EXTENSION UNIT (${location})`;

    return {
        channelId: `000${ceuString}`,
        channelNum: `SYS00${ceuString}`,
        channelName: channelName,
        channelType: systemChannelType,
        systemAlarmSetting: SystemAlarmSettingFns.createCeuSetting(ceuPorts),
        fcuNum: fcuNum,
    };
}

export function getEapChannel(eapNum: number, location?: string): SystemChannel {
    if (!eapNum || eapNum < 1 || eapNum > 32) return;
    let eapNumString = eapNum.toString().padStart(2, '0');

    let channelName = `NO.${eapNum} EXTENSION ALARM PANEL`;
    if (location) channelName = `NO.${eapNum} EXTENSION ALARM PANEL (${location})`;

    return {
        channelId: `00005${eapNumString}`,
        channelNum: `SYS005${eapNumString}`,
        channelName: channelName,
        channelType: systemChannelType,
        systemAlarmSetting: SystemAlarmSettingFns.createEapSetting(),
        fcuNum: 1,
    };
}
